import {IMenuItem, MenuItemType} from '@models/i-menu-item';

export const MENU_ITEMS: IMenuItem[] = [
  {
    id: MenuItemType.CropMonitoring,
    title: 'Crop monitoring',
    icon: '/assets/icons/main/light/ico-crop-summary.svg',
    cardStyle: {background: 'rgba(206, 127, 47, 0.5)'},
    url: '/crop-monitoring',
    iconBack: '/assets/icons/main/light/ico-tractor.svg',
    children:[
      {
        icon: 'assets/icons/main/light/ico-document.svg',
        iconBack: 'assets/icons/main/light/examination-request-back.svg',
        title: 'Examination requests',
        url: '/crop-monitoring/requests',
        cardStyle: { background: '#BDC8F2' }
      },
      {
        icon: 'assets/icons/main/light/icon-chart.svg',
        iconBack: 'assets/icons/main/light/ico-table-of-contents-reports-back.svg',
        title: 'Survey templates',
        url: '/crop-monitoring/mobile-templates',
        iconClass: 'table-of-contents-reports',
        cardStyle: { background: '#CCCFDA' }
      },
      {
        icon: 'assets/icons/main/light/icon-gis-fields.svg',
        iconBack: 'assets/icons/main/light/icon-gis-fields-back.svg',
        title: 'GIS',
        url: '/crop-monitoring/gis',
        cardStyle: { background: '#0088E94D' }
      },
      {
        icon: '/assets/icons/main/light/ico-report-summary-2.svg',
        iconBack: '/assets/icons/main/light/ico-bar-chart-fill.svg',
        title: 'Recommendations for farmers',
        url: '/crop-monitoring/recommendations-for-farmers',
        cardStyle: { background: 'rgba(205, 175, 255, 1)' },
      },
      {
        icon: 'assets/icons/main/light/anomaly-found.svg',
        title: 'ANOMALIES_MAP_PAGE_TITLE',
        url: '/crop-monitoring/anomalies-map',
        cardStyle: { background: 'rgba(220, 38, 38, 0.12)' },
      },
      {
        icon: 'assets/icons/main/light/ico-satellite-summary.svg',
        iconBack: 'assets/icons/main/light/icon-satellite-images-back.svg',
        title: 'Satellite Images',
        url: '/crop-monitoring/satellite-images',
        cardStyle: { background: '#8BAAFF' }
      },
    ]
  },
  {
    id: MenuItemType.ElectronicFieldMap,
    title: 'main_menu.electronic_field_maps',
    icon: '/assets/icons/main/light/ico-solid-composition.svg',
    cardStyle: {background: 'rgba(14, 81, 157, 0.3)'},
    url: '/electronic-field-map',
    iconBack: '/assets/icons/main/light/ico-passport-line.svg',
    children: [
      {
        icon: 'assets/icons/main/light/ico-field.svg',
        iconBack: 'assets/icons/main/light/ico-field-back.svg',
        title: 'Fields',
        url: '/electronic-field-map/fields',
        cardStyle: {background: '#81C70080'},
      },
      {
        icon: 'assets/icons/main/light/icon-field-tile-map.svg',
        iconBack: 'assets/icons/main/light/icon-field-tile-map-back.svg',
        title: 'Tile map',
        url: '/electronic-field-map/fields-passport',
        cardStyle: {background: '#B3E995'},
      },
      {
        icon: 'assets/icons/main/light/icon-upload-front.svg',
        iconBack: 'assets/icons/main/light/icon-upload-back.svg',
        title: 'Uploading images',
        url: '/electronic-field-map/upload-images',
        cardStyle: {background: '#FBD47F'},
      },
      {
        icon: 'assets/icons/main/light/icon-gis-fields.svg',
        iconBack: 'assets/icons/main/light/icon-gis-fields-back.svg',
        title: 'GIS',
        url: '/electronic-field-map/map',
        cardStyle: {background: '#74C977'},
      },
      {
        title: 'Crop calendar',
        icon: '/assets/icons/main/light/icon-calendar-crops.svg',
        cardStyle: {background: 'rgba(109, 222, 222, 0.8)'},
        url: '/electronic-field-map/calendar-crops',
        iconBack: '/assets/icons/main/light/icon-calendar-crops-back.svg',
      },
      {
        icon: 'assets/icons/main/light/import-menu.svg',
        iconBack: 'assets/icons/main/light/import-menu-background.svg',
        title: 'Import Fields',
        url: '/electronic-field-map/import-fields',
        cardStyle: {background: '#B8D5E2'},
      },
      {
        icon: 'assets/icons/main/light/icon-repots-front.svg',
        iconBack: 'assets/icons/main/light/icon-repots-back.svg',
        title: 'Reports',
        url: '/reports',
        cardStyle: {background: '#BABDC5'},
      },
      {
        title: 'Administration',
        cardStyle: {background: 'rgba(186, 189, 197, 0.8)'},
        url: '/admin/task-scheduler',
        queryParams: {module: 'Field'},
        iconBack: '/assets/icons/main/light/ico-admin-line.svg',
        icon: '/assets/icons/main/light/ico-admin-summary.svg',
      },
    ]
  },
  {
    id: MenuItemType.Weather,
    title: 'Weather',
    icon: '/assets/icons/main/light/ico-wheater-summary.svg',
    cardStyle: {background: 'rgba(242, 222, 0, 0.4)'},
    url: '/weather',
    iconBack: '/assets/icons/main/light/ico-sun-cloudy-fill.svg',
    children: [
      {
        title: 'GIS',
        icon: '/assets/icons/main/light/icon-gis-fields.svg',
        iconBack: '/assets/icons/main/light/icon-gis-fields-back.svg',
        cardStyle: {background: 'rgba(0, 136, 233, 0.3)'},
        url: '/weather/gis',
      },
      {
        title: 'Tile map',
        icon: '/assets/icons/main/light/icon-field-tile-map.svg',
        iconBack: '/assets/icons/main/light/icon-field-tile-map-back.svg',
        cardStyle: {background: 'rgba(54, 195, 26, 0.6)'},
        url: '/weather/tile-map',
      },
      {
        title: 'Reports',
        icon: 'assets/icons/main/light/icon-repots-front.svg',
        iconBack: 'assets/icons/main/light/icon-repots-back.svg',
        cardStyle: {background: 'rgba(186, 189, 197, 0.8)'},
        url: '/weather/reports',
      },
      {
        id: MenuItemType.WeatherAdministration,
        title: 'Administration',
        iconBack: '/assets/icons/main/light/ico-admin-line.svg',
        icon: '/assets/icons/main/light/ico-admin-summary.svg',
        cardStyle: {background: 'rgba(186, 189, 197, 0.8)'},
        url: '/weather/administration',
        children:[
          {
            icon: 'assets/icons/main/light/task-ead-icon.svg',
            iconBack: 'assets/icons/main/light/task-icon-line-chart-fill.svg',
            title: 'Task Scheduler',
            url: '/weather/administration/scheduler',
            cardStyle: { background: '#6DDE89' },
          },
          {
            icon: 'assets/icons/main/light/ico-document.svg',
            iconBack: 'assets/icons/main/light/normative-back-icon.svg',
            title: 'ProcessedDataProtocol',
            url: '/weather/administration/data-processing',
            cardStyle: { background: '#B48EFFCC' },
          },
          {
            icon: 'assets/icons/main/light/licon-ead-icon.svg',
            iconBack: 'assets/icons/main/light/user-icon-line-chart-fill.svg',
            title: 'Logging',
            url: '/weather/administration/logging',
            cardStyle: { background: '#B48EFFCC' },
          },
        ]
      },
    ]
  },
  {
    title: 'GENERAL_GIS.TITLE',
    icon: '/assets/icons/main/light/ico-map.svg',
    cardStyle: {background: 'rgba(91, 163, 217, 0.45)'},
    url: '/general-map',
    iconBack: '/assets/icons/main/light/ico-map-trifold.svg',
  },
  {
    id: MenuItemType.SatelliteData,
    title: 'Satellite Data',
    icon: '/assets/icons/main/light/ico-satellite-summary.svg',
    cardStyle: {background: 'rgba(109, 62, 250, 0.5)'},
    url: '/satellite-data',
    iconBack: '/assets/icons/main/light/ico-sattelite.svg',
    children: [
      {
        icon: 'assets/icons/main/light/ico-satellite-summary.svg',
        iconBack: 'assets/icons/main/light/ico-download-satellite-data-back.svg',
        title: 'Satellite Images',
        url: '/satellite-images',
        cardStyle: {background: '#0088FFB2'},
        isAdmin: true,
      },
      {
        icon: 'assets/icons/main/light/upload-imgs.svg',
        iconBack: 'assets/icons/main/light/upload-img-bg.svg',
        title: 'Administration',
        url: '/satellite-data/admin',
        cardStyle: {background: '#ffd859'},
        id: MenuItemType.SatelliteAdministration,
        children:[
          {
            icon: 'assets/icons/main/light/licon-ead-icon.svg',
            iconBack: 'assets/icons/main/light/user-icon-line-chart-fill.svg',
            title: 'Logging',
            url: '/satellite-images-admin',
            cardStyle: { background: '#B48EFFCC' },
          },
          {
            icon: 'assets/icons/main/light/task-ead-icon.svg',
            iconBack: 'assets/icons/main/light/task-icon-line-chart-fill.svg',
            title: 'Task Scheduler',
            url: '/satellite-data/scheduler',
            cardStyle: { background: '#6DDE89' },
          },
        ]
      }
    ]
  },
  {
    id: MenuItemType.UAV,
    title: 'UAV data',
    icon: '/assets/icons/main/light/ico-uav-summary.svg',
    cardStyle: {background: 'rgba(118, 189, 255, 1)'},
    url: '/uav-data',
    iconBack: '/assets/icons/main/light/ico-plane-fill.svg',
  },
  {
    id: MenuItemType.FieldIdentification,
    title: 'Fields identification',
    icon: '/assets/icons/main/light/ico-fields-identification-summary.svg',
    cardStyle: {background: 'rgba(53, 177, 31, 0.7)'},
    url: '/fields-identification',
    iconBack: '/assets/icons/main/light/ico-fields-identification-back.svg',
    children: [
      {
        title: 'Boundaries List',
        icon: '/assets/icons/main/light/ico-fields-identification-summary.svg',
        iconBack: '/assets/icons/main/light/ico-fields-identification-back.svg',
        cardStyle: { background: '#7FC2A099' },
        url: './list',
      },
      {
        title: 'GIS',
        icon: '/assets/icons/main/light/icon-gis-fields.svg',
        iconBack: '/assets/icons/main/light/icon-gis-fields-back.svg',
        cardStyle: { background: 'rgba(0, 136, 233, 0.3)' },
        url: './gis',
      },
    ]
  },
  {
    id: MenuItemType.CropIdentification,
    title: 'Crop identification',
    icon: '/assets/icons/main/light/ico-culture-summary.svg',
    cardStyle: { background: 'rgba(164, 195, 26, 0.7)' },
    url: '/crop-identification',
    iconBack: '/assets/icons/main/light/ico-crop.svg',
    children: [
      {
        title: 'Crop identification',
        icon: '/assets/icons/main/light/ico-culture-summary.svg',
        cardStyle: { background: 'rgba(164, 195, 26, 0.7)' },
        url: '/crop-identification/list',
        iconBack: '/assets/icons/main/light/ico-crop.svg',
      },
      {
        title: 'GIS',
        icon: '/assets/icons/main/light/icon-gis-fields.svg',
        iconBack: '/assets/icons/main/light/icon-gis-fields-back.svg',
        cardStyle: { background: 'rgba(0, 136, 233, 0.3)' },
        url: '/crop-identification/gis',
      },
    ]
  },
  {
    id: MenuItemType.CropYieldForecast,
    title: 'Crop Yield Forecasts',
    icon: '/assets/icons/main/light/ico-crop-yield-forecasts-summary.svg',
    cardStyle: {background: 'rgba(164, 195, 26, 0.7)'},
    url: '/crop-yield-forecasts',
    iconBack: '/assets/icons/main/light/ico-crop-yield-forecasts-back.svg',
    children: [
      {
        title: 'Yield Forecasting',
        icon: '/assets/icons/main/light/icon-repots-front.svg',
        iconBack: '/assets/icons/main/light/ico-table-of-contents-reports-back.svg',
        cardStyle: {background: '#7FC2A099'},
        url: './list',
      },
      {
        title: 'Yield Analysis',
        icon: '/assets/icons/main/light/icon-repots-front.svg',
        iconBack: '/assets/icons/main/light/ico-table-of-contents-reports-back.svg',
        cardStyle: {background: '#A0C27F99'},
        url: './analysis',
      },
    ]
  },
  {
    id: MenuItemType.Reports,
    title: 'reporting_analytics.title',
    icon: '/assets/icons/main/light/ico-report-summary-2.svg',
    cardStyle: {background: 'rgba(186, 189, 197, 0.8)'},
    url: '/reports',
    iconBack: '/assets/icons/main/light/ico-bar-chart-fill.svg',
    children: [
      {
        title: 'reporting_analytics.chat_assistant',
        icon: '/assets/icons/main/light/ico-report-summary-2.svg',
        iconBack: '/assets/icons/main/light/ico-bar-chart-fill.svg',
        url: '/reports',
        cardStyle: {background: '#B8E0C8'},
      },
    ],
  },
  {
    id: MenuItemType.Dictionaries,
    title: 'Dictionaries',
    icon: '/assets/icons/main/light/ico-dictionnary-summary.svg',
    cardStyle: {background: 'rgba(186, 189, 197, 0.8)'},
    url: '/dictionaries',
    iconBack: '/assets/icons/main/light/ico-book-2-line.svg',
    children: [
      {
        title: 'dictionaries.climateData',
        icon: '/assets/icons/main/light/dict-icon-lead-icon.svg',
        cardStyle: {background: 'rgba(195, 219, 249, 1)'},
        url: '/dictionaries/climate-data',
        iconBack: '/assets/icons/main/light/icon-map-2-line.svg',
      },
      {
        title: 'dictionaries.naturalResources',
        icon: '/assets/icons/main/light/nature-resource.svg',
        cardStyle: {background: 'rgba(158, 231, 174, 1)'},
        url: '/dictionaries/natural-resources',
        iconBack: '/assets/icons/main/light/nature-icon-survey-line.svg',
      },
      {
        title: 'dictionaries.agriculturalData',
        icon: '/assets/icons/main/light/agro-data.svg',
        cardStyle: {background: 'rgba(201, 174, 234, 1)'},
        url: '/dictionaries/agro-data',
        iconBack: '/assets/icons/main/light/icon-grass-file.svg',
      },
      {
        title: 'dictionaries.regions',
        icon: '/assets/icons/main/light/regions.svg',
        cardStyle: {background: 'rgba(245, 222, 130, 1)'},
        url: '/dictionaries/regions',
        iconBack: '/assets/icons/main/light/regions-icon-line-chart-fill.svg',
      },
      {
        title: 'dictionaries.legalEntities',
        icon: '/assets/icons/main/light/law.svg',
        cardStyle: {background: 'rgba(67, 143, 248, 0.7)'},
        url: '/dictionaries/firms',
        iconBack: '/assets/icons/main/light/law-icon-line-chart-fill.svg',
      },
      {
        title: 'dictionaries.individuals',
        icon: '/assets/icons/main/light/citizens.svg',
        cardStyle: {background: 'rgba(87, 190, 40, 0.6)'},
        url: '/dictionaries/persons',
        iconBack: '/assets/icons/main/light/ico-person-back.svg',
      },
      {
        title: 'dictionaries.generalDictionaries',
        icon: '/assets/icons/main/light/general-icon.svg',
        cardStyle: {background: 'rgba(182, 134, 67, 0.74)'},
        url: '/dictionaries/general-dictionaries',
        iconBack: '/assets/icons/main/light/general-back-icon.svg',
      },
      {
        title: 'dictionaries.normativeDocumentation',
        icon: '/assets/icons/main/light/ico-document.svg',
        cardStyle: {background: 'rgba(182, 191, 214, 1)'},
        url: '/dictionaries/normative-documents',
        iconBack: '/assets/icons/main/light/normative-back-icon.svg',
      }
    ]
  },
  {
    id: MenuItemType.Administration,
    title: 'Administration',
    icon: '/assets/icons/main/light/ico-admin-summary.svg',
    cardStyle: {background: 'rgba(186, 189, 197, 0.8)'},
    url: '/admin',
    iconBack: '/assets/icons/main/light/ico-admin-line.svg',
    children: [
      {
        icon: 'assets/icons/main/light/licon-ead-icon.svg',
        iconBack: 'assets/icons/main/light/user-icon-line-chart-fill.svg',
        title: 'Logging',
        url: '/admin/logging',
        cardStyle: { background: '#B48EFFCC' }
      },
      {
        icon: 'assets/icons/main/light/task-ead-icon.svg',
        iconBack: 'assets/icons/main/light/task-icon-line-chart-fill.svg',
        title: 'Task Scheduler',
        url: '/admin/task-scheduler',
        cardStyle: { background: '#6DDE89' }
      },
      {
        icon: 'assets/icons/main/light/system-lead-icon.svg',
        iconBack: 'assets/icons/main/light/system-icon-line-chart-fill.svg',
        title: 'System Status',
        url: '/admin/system-status',
        cardStyle: { background: '#0088FFB2' }
      },
      {
        icon: 'assets/icons/main/light/data-managment.svg',
        iconBack: 'assets/icons/main/light/data-management-back.svg',
        title: 'Data Management',
        url: '/admin/data-management',
        cardStyle: { background: '#c8cad1' }
      },
      {
        icon: 'assets/icons/main/light/user-help.svg',
        iconBack: 'assets/icons/main/light/user-help-back.svg',
        title: 'User Support',
        url: '/admin/appeals',
        cardStyle: { background: '#b8dde1' }
      },
      {
        icon: 'assets/icons/main/light/manage-file.svg',
        iconBack: 'assets/icons/main/light/manage-file-back.svg',
        title: 'File Storage Management',
        url: '/admin/file-storage',
        cardStyle: { background: '#c8cad1' }
      },
      {
        icon: 'assets/icons/main/light/manage-file.svg',
        iconBack: 'assets/icons/main/light/manage-file-back.svg',
        title: 'System Documentation',
        url: '/admin/system-documentation',
        cardStyle: { background: '#E8D5C4' }
      },
      {
        icon: 'assets/icons/main/light/manage-file.svg',
        iconBack: 'assets/icons/main/light/manage-file-back.svg',
        title: 'System Documentation Blocks',
        url: '/admin/system-documentation-blocks',
        cardStyle: { background: '#D4C5B8' }
      },
      {
        icon: 'assets/icons/main/light/system-lead-icon.svg',
        iconBack: 'assets/icons/main/light/system-icon-line-chart-fill.svg',
        title: 'adminMobileSettings.title',
        url: '/admin/mobile-settings',
        cardStyle: { background: '#A9C7F5' }
      },
    ]
  },
];
